export default function PageWrapper(props) {
  let newProps = { ...props };
  newProps.className =
    "d-flex flex-column align-items-center w-100 " + newProps.className;
  return <div {...newProps}></div>;
}
